// An event creator
function createEventPolyfill(name) {
  const AnEvent = (event, params = { bubbles: false, cancelable: false }) => {
    const evt = document.createEvent(name);

    switch (name) {
      case 'Event':
        evt.initEvent(event, params.bubbles, params.cancelable);
        break;
      case 'CustomEvent':
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        break;
      default: break;
    }

    return evt;
  };

  AnEvent.prototype = window.Event.prototype;
  return Object.defineProperty(window, name, { value: AnEvent });
}

function addEventPolyfills() {
  const names = ['Event', 'CustomEvent'];

  names.forEach((name) => {
    if (typeof window[name] !== 'function') {
      createEventPolyfill(name);
    }
  });
}

addEventPolyfills();
